import { render } from "./totp_form.vue?vue&type=template&id=27578ef6"
import script from "./totp_form.js?vue&type=script&lang=js&external"
export * from "./totp_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__